// Generated by `pnpm generate` from contracts/widget-types.yaml. Do not edit.
export const WIDGET_CATALOGUE_VERSION = "0.6.0";
export const WIDGET_TYPES = [
  "value",
  "value_grid",
  "toggle",
  "slider",
  "gauge",
  "line_chart",
  "bar_chart",
  "map",
  "compass",
  "status_list",
  "alarm_list",
  "schedule",
  "scene_button",
  "insight_card",
  "text",
  "image",
  "device_tile",
  "level",
  "sparkline",
  "stats",
  "state_timeline",
  "heatmap",
  "health",
  "period_totals",
  "period_compare",
  "year_compare",
  "weather_station",
  "reset_counter",
  "web_widget",
] as const;
export type WidgetType = (typeof WIDGET_TYPES)[number];
